import { ANALYTICS_API_NAME } from "./spnAnalytics/analyticsEnum";

class NetworkManager {
    /**
      * The constructor function is called when the object is created, and it's used to set up the
      * object.
      @param obj @type {Object} - get global class object
      */
    constructor(connectorObj) {
        this.apiRequest = connectorObj.apiRequest;
        this.baseUrl = connectorObj.analyticsConfig.BEACON_BASE_URL;
    }

    updateConfig(params) {
        this.baseUrl = params.BEACON_BASE_URL;
    }

    /**
     * This function will execute all backend related API.
     * @param post_data @type {json} - playload and event name & api name.
     */
    async networkProcessApi(post_data) {
        var API = this.baseUrl;
        //var API = this.connectorObj.BEACON_BASE_URL;
        var playload = post_data.payloadbody;

        switch (post_data.apiname) {
            case ANALYTICS_API_NAME.APP_SESSION_START:
            case ANALYTICS_API_NAME.APP_SESSION_END:
            case ANALYTICS_API_NAME.VIDEO_ATTEMPT:
            case ANALYTICS_API_NAME.VIDEO_ERROR:
            case ANALYTICS_API_NAME.VIDEO_PLAY:
            case ANALYTICS_API_NAME.VIDEO_SESSION_END:
            case ANALYTICS_API_NAME.VIDEO_SESSION_HEARTBEAT:
            case ANALYTICS_API_NAME.VIDEO_SESSION_START:
            case ANALYTICS_API_NAME.VIDEO_END:
            case ANALYTICS_API_NAME.APP_FORE_GROUND:
            case ANALYTICS_API_NAME.APP_BACK_GROUND:
            case ANALYTICS_API_NAME.VIDEO_SESSION_PULSE:
                var response = await this.apiRequest.postRequest(API, playload);
                return response.status;

            case ANALYTICS_API_NAME.ADS_ATTEMPT:
            case ANALYTICS_API_NAME.ADS_END:
            case ANALYTICS_API_NAME.ADS_ERROR:
            case ANALYTICS_API_NAME.ADS_HEARTBEAT:
            case ANALYTICS_API_NAME.ADS_PLAY:
                var response = await this.apiRequest.postRequest(API, playload);
                return response.status;

            default:
                return false;
        }
    }
}

export default NetworkManager;
